import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { usePageContext } from "../../utils/PageContext.js";
import { useApi } from "../../utils/useApi.js";
import "../../styles/typography.scss";
import Breadcrumbs from "../../components/Breadcrumbs/index.js";

export default function Exchange() {
  const { t } = useTranslation();
  const { lang, changeArticleType } = usePageContext();
  const { loading, data } = useApi("/tools/exchange");

  const categories = {
    title: {
      text_sq: t("tools.exchange"),
      text_en: t("tools.exchange"),
    },
    slug: "about",
    parentCategory: {
      title: {
        text_sq: t("tools.title"),
        text_en: t("tools.title"),
      },
      slug: "tools",
    },
  };

  return (
    <>
      <main className="main-content">
        <section>
          <div className="wrapper">
            <Breadcrumbs data={categories} />
          </div>
        </section>
        <header className="content-header content-header--spaced">
          <div className="wrapper">
            <h2 className="content-header__title">{t("exchange.title")}</h2>
            <h3 className="content-header__subtitle"></h3>
          </div>
        </header>
        <section className="site-block">
          <div className="wrapper">
            <div className="site-block__title">
              <div className="site-block__title-left"></div>
            </div>
            <div className="text">
              {/* <p>
                <small>към 02.04.2021 17:39</small>
              </p> */}
              {loading ? (
                <p>{t("pages.search.loading")}</p>
              ) : (
                <div className="scrollable-content">
                  <table>
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th>{t("exchange.unit")}</th>
                        <th>{t("exchange.buy")}</th>
                        <th>{t("exchange.sell")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item) => (
                        <tr key={`${item.Currency1}-${item.Currency2}`}>
                          <td style={{ textAlign: "center" }}>
                            {item.Currency1}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.Currency2}
                          </td>
                          <td style={{ textAlign: "center" }}>{item.Unit}</td>
                          <td style={{ textAlign: "center" }}>{item.Buy}</td>
                          <td style={{ textAlign: "center" }}>{item.Sell}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </section>
        <section className="site-block">
          <div className="wrapper wrapper--950">
            <div className="text">
              <h4>{t("exchange.notes")}:</h4>

              <ul>
                <li>{t("exchange.note_1")}</li>
                <li>{t("exchange.note_2")}</li>
                <li>{t("exchange.note_3")}</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
